// extracted by mini-css-extract-plugin
module.exports = {"mini-download-button":"mini-download-button_mini-download-button__2x_Yh"};